export interface CustomerLanguageType {
  value: string;
  label: { fr: string; en: string };
}

export const CUSTOMER_LANGUAGE_TYPES: CustomerLanguageType[] = [
  { value: "fr", label: { fr: "Français", en: "French" } },
  { value: "en", label: { fr: "Anglais", en: "English" } },
];
